import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import OneTimeSlotForm from './one-time-slot-form'

const useStyles = makeStyles(() => ({
  header: {
    borderBottom: 'none',
    paddingBottom: 0,
  },
}))

const labelFor = initialType => {
  if (initialType === 'block') return 'Add Blocked Time'
  if (initialType === 'open') return 'Add Open Time'
  return 'Add One-Time Slot'
}

const titleFor = initialType => {
  if (initialType === 'block') return 'Add Blocked Time'
  if (initialType === 'open') return 'Add Open Time'
  return 'Add One-Time Slot'
}

const OneTimeSlotDialog = ({
  facilities,
  onSuccess,
  triggerProps,
  initialType,
  compact,
  triggerless,
  isOpen,
  onClose,
  defaultFacilityId,
}) => {
  const classes = useStyles()
  const label = labelFor(initialType)

  const trigger = triggerless ? (
    undefined
  ) : compact ? (
    <IconButton color="primary" aria-label={label} title={label}>
      <AddOutlinedIcon />
    </IconButton>
  ) : (
    <Button
      variant="contained"
      color="primary"
      startIcon={<AddOutlinedIcon />}
      style={{ whiteSpace: 'nowrap' }}
      {...triggerProps}
    >
      {label}
    </Button>
  )

  return (
    <Dialog
      trigger={trigger}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      showCloseButton
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle className={classes.header}>
            {titleFor(initialType)}
          </DialogTitle>
          <DialogContent>
            <Box pb={2}>
              <OneTimeSlotForm
                facilities={facilities}
                initialType={initialType}
                defaultFacilityId={defaultFacilityId}
                onSuccess={() => {
                  onSuccess && onSuccess()
                  closeDialog()
                }}
                onCancel={closeDialog}
              />
            </Box>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default OneTimeSlotDialog
